import { columns, mobileColumns } from './Column'
import ReactDataTable from '../../../../../../../components/_shared/Table/ReactDataTable'
import useWindowSize from '../../../../../../../../utils/hooks/useWindowSize'
import ReactExpandableTable from '../../../../../../../components/_shared/Table/ReactExpandableTable'
import { Alert } from 'react-bootstrap'
import ReportFooter from '../../ReportsFooter/ReportFooter'
const SystemReportTable = ({
    DisplayDate,
    SystemReportData,
    downloadPDF,
    downloadExcel,
    isLoading,
    reportData,
    reportCode,
    reportTableData,
    generatePDFFunction,
}) => {
    const size = useWindowSize()
    if (size.width < 768) {
        return (
            <>
                <h1 className="mb-2">System Report</h1>
                <p className="fw-bold mb-4">
                    Date Range:{' '}
                    <span className="text-muted fw-normal">
                        {DisplayDate?.startDate} thru {DisplayDate?.endDate}
                    </span>
                </p>

                <ReactExpandableTable
                    isLoading={isLoading}
                    data={SystemReportData}
                    mobileColumns={mobileColumns}
                    removePagination={true}
                />
                {/* {!SystemReportData && !isLoading &&(
                    <Alert variant={'danger'} className="my-4" dismissible>
                        No Record Found
                    </Alert>
                )
                } */}

                <ReportFooter
                    BackText={'Back'}
                    PdfText={'PDF'}
                    MailText={'Mail'}
                    ExcelText={'Excel'}
                    onPdfClick={downloadPDF}
                    onExcelClick={downloadExcel}
                    reportData={reportData}
                    reportCode={reportCode}
                    reportTableData={reportTableData}
                    generatePDFFunction={generatePDFFunction}
                />
            </>
        )
    }

    return (
        <>
            <h1 className="mb-2">System Report</h1>
            <p className="fw-bold mb-4">
                Date Range:{' '}
                <span className="text-muted fw-normal">
                    {DisplayDate?.startDate} thru {DisplayDate?.endDate}
                </span>
            </p>
            <>
                <ReactDataTable
                    isLoading={isLoading}
                    data={SystemReportData}
                    columns={columns}
                    removePagination={true}

                />
                {/* {!SystemReportData && !isLoading && (
                    <Alert variant={'danger'} className="my-4" dismissible>
                        No Record Found
                    </Alert>
                )    
            } */}
            </>

            <ReportFooter
                BackText={'Back'}
                PdfText={'PDF'}
                MailText={'Mail'}
                ExcelText={'Excel'}
                onPdfClick={downloadPDF}
                onExcelClick={downloadExcel}
                reportData={reportData}
                reportCode={reportCode}
                reportTableData={reportTableData}
                generatePDFFunction={generatePDFFunction}
            />
        </>
    )
}

export default SystemReportTable
